// Build signature & diagnostics helper. Imported by index.tsx.
// Update VERSION when releasing a meaningful change affecting remote consumers.
// In CI you can template this file or replace at build time.
const VERSION = '1.0.0';
const signature = {
  version: VERSION,
  buildTime: new Date().toISOString(),
  // Attempt to read environment override for debugging
  envApiUrl: (typeof process !== 'undefined' && process.env && process.env.REACT_APP_DRIVE_API_URL) || undefined,
};

type DriveDebugWindow = Window & {
  __DRIVE_BUILD_SIGNATURE__?: typeof signature;
  __DRIVE_DEBUG__?: boolean;
};
// Expose global for manual verification in production
if (typeof window !== 'undefined') {
  const driveWindow = window as DriveDebugWindow;
  driveWindow.__DRIVE_BUILD_SIGNATURE__ = signature;
  // eslint-disable-next-line no-console
  if (driveWindow.__DRIVE_DEBUG__ !== false) console.log('[driveApi] signature attached', signature);
}
export default signature;
